import { useState, useEffect } from 'react';

// Định dạng ngày kiểu Việt Nam (dd/mm/yyyy), độc lập với locale trình duyệt.

// 'yyyy-mm-dd' (hoặc ISO datetime) -> 'dd/mm/yyyy'
export const dmy = (iso) => {
  const [y, m, d] = String(iso || '').slice(0, 10).split('-');
  return y && m && d ? `${d}/${m}/${y}` : (iso || '');
};

// Date object -> 'dd/mm/yyyy'
export const dmyDate = (d) =>
  (!d || isNaN(d)) ? '' :
    `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;

// ISO datetime -> 'dd/mm/yyyy HH:mm'
export function dmyTime(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return iso || '—';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

// Chèn dấu '/' tự động khi gõ số (dd/mm/yyyy).
function autoSlash(v) {
  const g = v.replace(/\D/g, '').slice(0, 8);
  return [g.slice(0, 2), g.slice(2, 4), g.slice(4, 8)].filter(Boolean).join('/');
}

// DateInput: nhập/hiển thị dd/mm/yyyy nhưng lưu ISO 'yyyy-mm-dd' cho backend.
// Kèm nút lịch (native picker) bên phải để chọn nhanh.
export function DateInput({ value, onChange, placeholder }) {
  const [text, setText] = useState(dmy(value));
  useEffect(() => { setText(dmy(value)); }, [value]);

  function onText(e) {
    const t = autoSlash(e.target.value);
    setText(t);
    const m = t.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (m) onChange(`${m[3]}-${m[2]}-${m[1]}`);
    else if (t === '') onChange('');
  }

  return (
    <span className="date-field">
      <input
        className="date-text" type="text" inputMode="numeric" maxLength={10}
        placeholder={placeholder || 'dd/mm/yyyy'} value={text}
        onChange={onText}
        onBlur={() => setText(dmy(value))}
      />
      <input
        className="date-pick" type="date" tabIndex={-1} aria-label="Chọn ngày"
        value={value || ''} onChange={(e) => onChange(e.target.value)}
      />
    </span>
  );
}
